import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { BaseService } from './base.service';

export type EnvSyncDirection = 'dev_to_prod' | 'prod_to_dev';

export interface EnvSyncDeployment {
  deploymentEnv: 'dev' | 'prod';
  peerConfigured: boolean;
  peerApiUrl?: string | null;
  canPushDevToProd?: boolean;
}

export interface EnvSyncSectionRow {
  key: string;
  label: string;
  toolsPath?: string;
  disabled?: boolean;
  disabledReason?: string | null;
  handlerReady?: boolean;
  pushable?: boolean;
  lastUpdated?: string | null;
  lastSynced?: string | null;
  lastUpdatedDev?: string | null;
  lastUpdatedProd?: string | null;
  canPushDevToProd?: boolean;
  canPushProdToDev?: boolean;
}

export interface EnvSyncBusinessRulesResponse {
  deploymentEnv: 'dev' | 'prod';
  peerConfigured: boolean;
  peerError?: string;
  companyId: string;
  sections: EnvSyncSectionRow[];
}

export interface EnvSyncAiReview {
  sectionKey: string;
  label: string;
  localEnv?: 'dev' | 'prod';
  peerEnv?: 'dev' | 'prod';
  aiSkipped?: boolean;
  message?: string;
  summary?: string;
  differences?: string[];
  risks?: string[];
  recommendation?: string;
}

@Injectable()
export class EnvSyncService extends BaseService {
  constructor(protected override http: HttpClient) {
    super(http, `${environment.apiBaseUrl}/companies/%(company_id)s/sync`);
  }

  getDeployment(): Observable<EnvSyncDeployment> {
    return this.http.get<EnvSyncDeployment>(`${environment.apiBaseUrl}/sync/deployment`);
  }

  listBusinessRules(companyId: string): Observable<EnvSyncBusinessRulesResponse> {
    return this.http.get<EnvSyncBusinessRulesResponse>(
      `${environment.apiBaseUrl}/companies/${companyId}/sync/business_rules`,
    );
  }

  pushSection(companyId: string, sectionKey: string, direction: EnvSyncDirection): Observable<any> {
    return this.http.post(
      `${environment.apiBaseUrl}/companies/${companyId}/sync/sections/${sectionKey}/push`,
      { direction },
    );
  }

  getSectionAiReview(companyId: string, sectionKey: string): Observable<EnvSyncAiReview> {
    return this.http.get<EnvSyncAiReview>(
      `${environment.apiBaseUrl}/companies/${companyId}/sync/sections/${sectionKey}/ai-review`,
    );
  }
}
